module.exports = __webpack_public_path__ + "static/tiesto-e156f88a1d0e80f8ff03fa06fcc89fff.png";